import { render } from "./sendmail.vue?vue&type=template&id=ec6ccc26&scoped=true"
import script from "./sendmail.vue?vue&type=script&lang=js"
export * from "./sendmail.vue?vue&type=script&lang=js"

import "./sendmail.vue?vue&type=style&index=0&id=ec6ccc26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec6ccc26"]])

export default __exports__